<template>
  <div>
    <v-skeleton-loader class="header--loader" type="chip"></v-skeleton-loader>
    <div class="mb-10"></div>
    <v-skeleton-loader
      v-for="n in 7"
      :key="'btn--loader' + n + '1'"
      class="btn--loader"
      type="chip"
    ></v-skeleton-loader>
    <div class="mb-10"></div>
    <v-skeleton-loader
      v-for="n in 4"
      :key="'btn--loader' + n + '2'"
      class="btn--loader"
      type="chip"
    ></v-skeleton-loader>
    <div class="mb-10"></div>
    <v-skeleton-loader
      v-for="n in 7"
      :key="'btn--loader' + n + '3'"
      class="btn--loader"
      type="chip"
    ></v-skeleton-loader>
    <div class="mb-10"></div>
  </div>
</template>

<script>
export default {
  name: 'VideoSettingsLoader',
}
</script>
<style lang="scss" scoped>
.v-skeleton-loader.v-skeleton-loader--is-loading.btn--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 48px !important;
    width: auto !important;
    margin: 4px 0 !important;
  }
}
.v-skeleton-loader.v-skeleton-loader--is-loading.header--loader::v-deep {
  .v-skeleton-loader__chip {
    border-radius: 4px !important;
    height: 64px !important;
    width: 100% !important;
    margin: 4px 0 !important;
  }
}
</style>
